import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';
import { Props } from './types';
import { hexToRgb } from '@/components/util';

type T = Props & AppStyledProps;

export const RootStyled = styled.div<T>`
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.65);
  z-index: 120;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  color: white;
  font-size: 16px;
  font-family: Roboto;

  ${({ background, opacity, color, theme }) => {
    let styles = '';
    if (background && opacity) {
      const { r, g, b } = hexToRgb(background);
      styles += `background-color: rgba(${r},${g},${b}, ${opacity});`;
    }
    if (color) {
      styles += `color: ${color};`;
    }
    if (theme.device.mobile) {
      styles += '';
    }
    return styles;
  }}
`;
